import { useCallback } from "react"
import { setIsLoading } from "../../application/states/loading"
import { useAppDispatch } from "../../presentation/hooks/store-hooks"

export const useUIService = () => {
  const dispatch = useAppDispatch()

  const setLoading = useCallback((data: {
    loading: boolean
    message?: string
    id: string
  }) => {
    dispatch(setIsLoading({
      isLoading: data.loading
    }))
  }, [dispatch])

  const changeTitleAndMetaDesc = useCallback((data: {
    title: string
    metaDesc: string
  }) => {
    document.title = data.title
    const metaDesc = document.querySelector('meta[name="description"]')
    metaDesc?.setAttribute('content', data.metaDesc)
  }, [])

  return {
    setLoading,
    changeTitleAndMetaDesc
  }
}
